export const names = {
  name: 'name',
  slug: 'slug',
  parameters: 'parameters',
  fields: 'fields',
} as const;

export const featureFlags = {
  search: false,
  sources: false,
  parameters: false,
  bulkReplace: false,
};
